module.exports = __webpack_public_path__ + "static/img/pj1-4.c2db4ab.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/pj1-4.png
// module id = 713
// module chunks = 0